// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kETN","placeholdersHeader":"styles_placeholdersHeader__1k6m9","editorStyle":"styles_editorStyle__2uxS_","placeholdersBox":"styles_placeholdersBox__3CTxU"};